/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Process_Step1_DescInputs */

const et_process_step1_desc = /** @type {(inputs: Process_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vali sobiv pakett ja täida vorm.`)
};

const en_process_step1_desc = /** @type {(inputs: Process_Step1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a suitable plan and fill out the form.`)
};

/**
* | output |
* | --- |
* | "Choose a suitable plan and fill out the form." |
*
* @param {Process_Step1_DescInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const process_step1_desc = /** @type {((inputs?: Process_Step1_DescInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Process_Step1_DescInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_process_step1_desc(inputs)
	return en_process_step1_desc(inputs)
});